/** The recap's words: a caption per award and a line per personality. Playful, never mean. */

export const AWARD_CAPTIONS: Record<string, string> = {
  icebreaker: "The chat goes quiet. You simply refuse to let it.",
  speed_demon: "Typing before the message has even landed.",
  left_on_read: "Good things come to those who wait. A long, long time.",
  novelist: "Why say it in five words when you could use fifty?",
  one_word_wonder: "Efficient. Mysterious. Possibly asleep.",
  editor: "Every message gets a second draft.",
  double_texter: "Nobody answered, so you answered yourself.",
  three_am_club: "Sleep is a suggestion, and you declined it.",
  early_bird: "First one in, every single morning.",
  last_word: "When you talk, the chat goes quiet. Respectfully.",
  necromancer: "Raising week-old messages from the dead.",
  caps_lock: "WHY WHISPER WHEN YOU CAN SHOUT.",
  question_mark: "Curiosity didn't kill this cat. It made it chatty.",
  streak: "Showed up every day like it was a job.",
  call_captain: "If there's a call, you're already in it.",
  call_starter: "Ringing the group before anyone can say no.",
  hall_of_fame: "Your words, pinned for history.",
  comedian: "Your messages keep the whole chat laughing.",
  laugh_track: "Every joke gets a laugh. You're the laugh.",
  main_character: "The chat can't stop @-ing you.",
  summoner: "When you need someone, everyone gets a ping.",
  reply_magnet: "Say anything and the replies come running.",
  viral_moment: "One message. The whole chat had thoughts.",
  ghost: "Vanished without a trace, then strolled back in.",
  comeback_kid: "Disappeared for weeks, came back swinging.",
  apologiser: "Sorry for winning this award. Sorry.",
  exclamation_station: "Everything is exciting!!! Always!!!",
  nooooo_champion: "Why use one letter when ten will do?",
  lowercase_loyalist: "capital letters are a scam and you know it",
  full_stop: "Ends every sentence. Like this.",
  emoji_overlord: "Words are optional. Emoji are not.",
  meme_lord: "The chat's unofficial meme supplier.",
  gif_goblin: "Why type a reaction when a GIF says it better?",
  link_dumper: "Never met a link you didn't share.",
  the_dj: "The chat's unofficial playlist curator.",
  rename_royalty: "The chat's name is whatever you say it is.",
  weekend_warrior: "Quiet all week, unstoppable on Saturday.",
  spoiler_alert: "Hides the good stuff behind the black bars.",
  special_guest_star: "Rare appearances, every one memorable.",
  quality_over_quantity: "Doesn't say much, but people listen.",
};

export const TYPE_DESCRIPTIONS: Record<string, string> = {
  "The Town Crier": "Up with the sun, announcing whatever's on your mind, short and loud.",
  "The Meme Courier": "You start the day by delivering memes, express.",
  "The Columnist": "Daytime think pieces, posted for the whole chat to digest.",
  "The Curator": "You open conversations with links and a full write-up to go with them.",
  "The Hype Squad": "Quick, loud, supportive. Every message gets a reaction from you.",
  "The Reaction GIF": "Why reply in words when the perfect GIF exists?",
  "The Agony Aunt": "The one who answers properly, with paragraphs and care.",
  "The Fact Checker": "You reply with sources. Receipts, even.",
  "The 2 AM Thought": "The chat is asleep and you have a question. Urgently.",
  "The Midnight Meme Dealer": "After dark, you're the chat's main meme supplier.",
  "The Midnight Novelist": "Late at night, the long messages come out.",
  "The Rabbit Hole": "Midnight deep dives, links and all, and you're taking everyone with you.",
  "The Night Watch": "Still awake, still answering, short and quick.",
  "The Sleepless Reactor": "Replying with reactions at hours that should be illegal.",
  "The Late-Night Therapist": "When it's late and someone needs to talk, you're there in full.",
  "The Night Librarian": "Late-night replies that come with a reading list.",
};

export const TRAIT_LABELS = {
  time: { night: "Night owl", day: "Daytime" },
  role: { starter: "Starter", replier: "Replier" },
  length: { short: "Short texts", long: "Long texts" },
  medium: { words: "Words", memes: "Memes" },
} as const;

export const CLOCK_KINDS = {
  night_owl: "Certified night owl",
  early_bird: "Early bird",
  daytime: "Daytime regular",
  evening: "Evening person",
} as const;
